import { AuthContext } from "@/providers";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

export const useProtected = () => {
  const [state] = AuthContext.useActor();
  const navigate = useNavigate();

  useEffect(() => {
    if (state.matches("unauthenticated")) {
      navigate("/auth/login");
    } else if (state.matches("unverified")) {
      navigate("/auth/verify");
    }
  }, [state, navigate]);
};
